import { combineReducers } from 'redux';
import loginPage from '../reducers/login';
import userData from '../reducers/data_user';
import ultraMikro from '../reducers/ultra_mikro';
import brilink from '../reducers/brilink';
import bridaya from '../reducers/bridaya';
import merchant from '../reducers/merchant';
import link5 from '../reducers/link5';
import userTracking from '../reducers/user_tracking';

const rootReducer = combineReducers({
  loginPage,
  userData,
  ultraMikro,
  brilink,
  bridaya,
  merchant,
  link5,
  userTracking
});

export default rootReducer;
